import React from 'react'
import ReactDOM from 'react-dom'
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Link
} from "react-router-dom"
import {
	Provider
} from 'mobx-react'

import Home from './page/Home'
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import './index.less'
import { LocaleProvider } from 'antd';
import * as serviceWorker from './serviceWorker';

if (process.env.NODE_ENV === "production") {
	window.console.log = () => { }
	window.console.warn = () => { }
	window.console.info = () => { }
}

ReactDOM.render(
	<LocaleProvider locale={zh_CN}>
		<Router>
			<Home />
		</Router>
	</LocaleProvider>
	, document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();